/**
 * The component class, all js modules should extend this to give easy access to the
 * root DOM node of the module, it's data attributes (props) and any direct children
 * that we need to reference (refs)
 */
class Component {
    /**
     * Constructor
     * @param {object} config All the config options
     */
    constructor(config) {
        /**
         * The mounting point for the App component
         * @type {DOMNode}
         */
        this.mount = config.mount;
        /**
         * The root DOM node of this component
         * @type {DOMNode}
         */
        this.root = config.root;

        this.getProps();
        this.getRefs();
    }

    /**
     * a public facing hook to call once all the initalisation has taken place
     */
    componentDidMount() { }

    /**
     * Grabs all the data attributes from the root element and stores them in this.props
     * the component and ref props are ignored
     */
    getProps() {
        this.props = Object.keys(this.root.dataset).reduce(
            (accumulator, prop) =>
                (prop !== 'component' && prop !== 'ref'
                    ? Object.assign({}, accumulator, { [prop]: this.root.dataset[prop] })
                    : accumulator),
            {}
        );
    }

    /**
     * Grab any direct descendants that have a data-ref attribute
     * also calls componentDidMount so that any component level callback can run
     */
    getRefs() {
        this.refs = [...this.root.children].reduce(
            (accumulator, element) =>
                (element.dataset && element.dataset.ref
                    ? Object.assign({}, accumulator, { [element.dataset.ref]: element })
                    : accumulator),
            {}
        );

        this.componentDidMount();
    }
}

export default Component;



// WEBPACK FOOTER //
// ./scripts/utilities/component.js